(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a5-product-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('a5-delivery-estimate')) {
  customElements.define('a5-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const selector = this.querySelector('[data-delivery-selector]');
      const region = this.querySelector('[data-delivery-region]');
      const result = this.querySelector('[data-delivery-result]');
      if (!selector || !region || !result) return;
      this.ready = true;
      const initial = Array.from(result.childNodes).map(node => node.cloneNode(true));
      region.addEventListener('change', () => {
        const rate = this.querySelector(`template[data-delivery-rate="${region.value}"]`);
        result.replaceChildren(...(rate ? [rate.content.cloneNode(true)] : initial.map(node => node.cloneNode(true))));
      });
      selector.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
